import React from 'react';

import '../index.css';

export default function Square(props) {

  return (
    <div className={"square " + props.shade}
      onClick={props.onClick}
      // style={props.style}
      key={props.keyVal}
    >
      <div className="squareItem" style={props.style}></div>
    </div>
  );

}
